// Older section docs store numbers as strings ("12.5") or "" when unset. v-number-input shows "" as 0,
// so fields bound to those values read them through this helper.
export function toNumberOrNull(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const number = Number(value);
  return isNaN(number) ? null : number;
}
